import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  Reimbursement,
  ReimbursementReceiptDetails,
  ReimbursementSubmission,
} from './reimbursementsTypes'
import {
  getMySubmissions,
  getAllEmployeeSubmissions,
  getEmployeeSubmissions,
  getReceiptDetails,
} from './reimbursementsActions'

export interface ReimbursementsState {
  // Employee's own reimbursements
  mySubmissions: Reimbursement[] | null
  // Admin view of all employee submissions
  allEmployeeSubmissions: ReimbursementSubmission[] | null
  // One employee's receipts for the commuter drawer
  employeeSubmissions: ReimbursementSubmission[] | null
  employeeSubmissionsEmployeeId: string | null
  employeeSubmissionsLoading: boolean
  employeeSubmissionsError: string | null
  // Admin - details for a single receipt
  receiptDetails: ReimbursementReceiptDetails | null
  // Shared
  loading: boolean
  error: string | null
}

const initialState: ReimbursementsState = {
  mySubmissions: null,
  allEmployeeSubmissions: null,
  employeeSubmissions: null,
  employeeSubmissionsEmployeeId: null,
  employeeSubmissionsLoading: false,
  employeeSubmissionsError: null,
  receiptDetails: null,
  loading: false,
  error: null,
}

const reimbursementsSlice = createSlice({
  name: 'reimbursements',
  initialState,
  reducers: {
    // Employee reducers
    getMySubmissionsSuccess(state, action: PayloadAction<Reimbursement[]>) {
      state.mySubmissions = action.payload
      state.loading = false
      state.error = null
    },
    getMySubmissionsFailed(state, action: PayloadAction<string>) {
      state.loading = false
      state.error = action.payload
    },
    // Admin reducers
    getAllEmployeeSubmissionsSuccess(
      state,
      action: PayloadAction<ReimbursementSubmission[]>
    ) {
      state.allEmployeeSubmissions = action.payload
      state.loading = false
      state.error = null
    },
    getAllEmployeeSubmissionsFailed(state, action: PayloadAction<string>) {
      state.loading = false
      state.error = action.payload
    },
    setEmployeeSubmissionsLoading(state, action: PayloadAction<boolean>) {
      state.employeeSubmissionsLoading = action.payload
    },
    getEmployeeSubmissionsSuccess(
      state,
      action: PayloadAction<{
        employeeId: string
        receipts: ReimbursementSubmission[]
      }>
    ) {
      state.employeeSubmissions = action.payload.receipts
      state.employeeSubmissionsEmployeeId = action.payload.employeeId
      state.employeeSubmissionsLoading = false
      state.employeeSubmissionsError = null
    },
    getEmployeeSubmissionsFailed(state, action: PayloadAction<string>) {
      state.employeeSubmissions = null
      state.employeeSubmissionsEmployeeId = null
      state.employeeSubmissionsLoading = false
      state.employeeSubmissionsError = action.payload
    },
    getReceiptDetailsSuccess(
      state,
      action: PayloadAction<ReimbursementReceiptDetails>
    ) {
      state.receiptDetails = action.payload
      state.loading = false
      state.error = null
    },
    getReceiptDetailsFailed(state, action: PayloadAction<string>) {
      state.loading = false
      state.error = action.payload
    },
    // Shared
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
  },
})

export const reimbursementsActions = {
  ...reimbursementsSlice.actions,
  getMySubmissions,
  getAllEmployeeSubmissions,
  getEmployeeSubmissions,
  getReceiptDetails,
}

export const reimbursementsReducer = reimbursementsSlice.reducer
